module.exports = __webpack_public_path__ + "static/img/quanmin_footer_btn.b02abf2a.png";